import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import WidgetsList from './widget/WidgetsList'

const WbhookDetails = () => {
  return (
    <Grid justify="flex-start" align="flex-start" paddingGutter={0.5} wrap>
      <Col width="100%">
        <WidgetsList />
      </Col>
    </Grid>
  )
}

export default WbhookDetails
